import api from '../api-methods'

const proxyApi =
  process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

export default {
  getConfigurationInfos: (payload) => {
    return api.get(`${proxyApi}/v3/job_infos`, payload)
  },
  getConfigurationDetail: (id, payload) => {
    return api.get(`${proxyApi}/v3/job_info/${id}`, payload)
  },
  getConfigurationInvitations: (payload) => {
    return api.get(`${proxyApi}/v3/job_info_invitations`, payload)
  },
  getInvitationId: (payload) => {
    return api.post(`${proxyApi}/v3/job_info_invitations`, payload)
  },
  updateInvitationData: (payload) => {
    return api.put(`${proxyApi}/v3/job_info_invitations`, payload)
  },
}
